export default {
  list: {
    subtitle: '国际物流信息化，本就不该存在孤岛',
    searchPlaceholder: '搜索API名称，按Enter搜索',
    noResults: '未找到相关API接口',
    noResultsHint: '请尝试调整搜索关键词或筛选条件',
  },
  card: {
    viewDocs: '查看文档',
    statusAvailable: '可用',
    statusUnavailable: '不可用',
  },
  categories: {
    systemSettings: '系统设置',
    orderCenter: '订单中心',
    customerCenter: '客商中心',
    superRate: '超级运价',
    vasProcessor: 'vas 接口处理器'
  }
}

